import {
  AccordionSummary as MuiAccordionSummary,
  Box,
  Grid,
  SvgIcon,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import ArrowDown from '../../../../icons/svg/arrow_down.svg?react';

import { Row } from './index';

const StyledAccordionSummary = styled(MuiAccordionSummary)(() => ({
  minHeight: '42px',

  '& .MuiAccordionSummary-content': {
    margin: '0'
  },
  '& .MuiAccordionSummary-expandIconWrapper svg': {
    color: '#0D284B'
  },
  '& .Mui-expanded.MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(180deg)'
  }
}));

type Props = {
  headlineData: Row;
  withPadding?: boolean;
  startIcon?: JSX.Element;
};

export const AccordionSummary: FC<Props> = ({ headlineData, withPadding, startIcon }) => {
  return (
    <StyledAccordionSummary
      expandIcon={<SvgIcon component={ArrowDown} />}
      sx={{
        paddingX: withPadding ? '24px' : '0px'
      }}
    >
      <Grid
        container
        item
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        {startIcon && <Box marginRight={2}>{startIcon}</Box>}
        <Typography className="font-normal text-left ">{headlineData.mainText}</Typography>
        <Typography className="flex-1 font-normal text-left">
          {headlineData.secondaryText ? headlineData.secondaryText : ''}
        </Typography>
      </Grid>
    </StyledAccordionSummary>
  );
};
